import React from "react";
import MuiBaseModal from "../../common/modal/MuiModal";
import { AccessTokenSchema } from "../../../services/Schemas/AccessToken";
import CreateTokenForm from "../../../forms/token-edit-create/CreateTokenForm";

interface ICreateRole {
  onClose: (payload: boolean) => void;
  handleReload?: () => void;
  tokenInfo?: AccessTokenSchema;
  open: boolean;
}

export default function CreateAccessTokenModal({
  onClose,
  open,
  tokenInfo,
  handleReload,
}: ICreateRole) {
  return (
    <MuiBaseModal
      open={open}
      onClose={() => onClose(false)}
      title={tokenInfo ? "ویرایش توکن" : "ایجاد توکن"}
      hasCloseIcon
    >
      <CreateTokenForm
        onSuccess={() => {
          onClose(false);
          handleReload?.();
        }}
      />
    </MuiBaseModal>
  );
}
